import { render } from "./OcrProcessStatus.vue?vue&type=template&id=47e89fe0"
import script from "./OcrProcessStatus.vue?vue&type=script&lang=js"
export * from "./OcrProcessStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__